export default __webpack_public_path__ + "static/media/netbeans.a516f588.svg";